import { render, staticRenderFns } from "./TabelaMunicipio.vue?vue&type=template&id=4cecff92&scoped=true&"
import script from "./TabelaMunicipio.vue?vue&type=script&lang=js&"
export * from "./TabelaMunicipio.vue?vue&type=script&lang=js&"
import style0 from "./TabelaMunicipio.vue?vue&type=style&index=0&id=4cecff92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cecff92",
  null
  
)

export default component.exports